// Reconstructed from the supplied production build; original component names were unavailable.
function formatRequestDate(a) {
  return a
    ? new Date(a).toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "";
}
function formatRequestTime(a) {
  return a
    ? new Date(a).toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";
}
const requestStatusClasses = {
  approved: "bg-green-50 text-green-700 border-green-100",
  pending: "bg-yellow-50 text-yellow-600 border-yellow-100 animate-pulse",
  rejected: "bg-red-50 text-red-600 border-red-100",
  default: "bg-slate-100 text-slate-500 border-slate-200",
};
export { formatRequestDate, formatRequestTime, requestStatusClasses };
